import { Col, Dropdown, MenuProps, message, Modal, Row, Space, Spin, Table, Tabs, Tooltip } from 'antd';
import React, { ReactNode, useEffect, useMemo, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Card, Button } from 'antd';
import HeadingTypography from '../../shared/Typography/Heading';
import { BaseLayoutComponent, DocumentsUpload } from '../../shared';
import { Content } from 'antd/es/layout/layout';
import TextTypography from '../../shared/Typography/Text';
import {
  formateDbDocuments,
  formateDbGurantors,
  IDocument,
  IGuarantor,
  ILeadCommentsEntity,
  ILeadProductEntity,
  IProcurementEntity,
  IUserEntity,
  UploadedFile,
} from '@rasayi-workspace/shared';
import useGetLeadsBasicData from 'src/app/hooks/useGetLeadsBasicData';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { getFileFromFilename } from '../../../services/lead';
import GuarantorsDetails from '../lead-detail/guarantorsData';
import { GetTableItems } from '@services';
import { DEFAULT_TABLE_STATE } from '@constants';
import { ColumnsType } from 'antd/es/table';
import MoreIcon from '../../../../assets/icons/moreIcon';
import { EditOutlined, ExportOutlined, EyeOutlined } from '@ant-design/icons';
import TabPane from 'antd/es/tabs/TabPane';

interface IFilterItemProps {
  children: ReactNode;
  item: ILeadProductEntity;
}

export interface ICustomerValues {
    id?: string;
    first_name: string;
    last_name: string;
    email: string;
    primary_mobile: string;
    secondary_mobile?: string;
    cnic_number: string;
    dob: string;
    gender: string;
    province: string;
    city: string;
    address_line1: string;
}

const CustomerDetails = () => {
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    useGetLeadsBasicData();

    const fetchCustomer = async (id: string) => {
        try {
            setIsLoading(true);
            const query = `filter=id,eq,${id}`;
            const res = await GetTableItems<IUserEntity>(
                `user?${query}`,
                [
                    'roles',
                    'documents',
                    'leads',
                    'leads.products',
                    'leads.products.product_type',
                    'leads.products.brand',
                    'leads.comments',
                    'leads.comments.user',
                    'leads.products.product_type',
                    'leads.products.instalment_plan',
                    'leads.credit',
                    'leads.guarantors',
                ],
                [],
                DEFAULT_TABLE_STATE
            );
            setLeaddata(res.items[0]);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    };

    const [customerInfo, setCustomerInfo] = useState<ICustomerValues>({
        id: '',
        first_name: '',
        last_name: '',
        email: '',
        primary_mobile: '',
        secondary_mobile: '',
        cnic_number: '',
        dob: '',
        gender: '',
        province: '',
        city: '',
        address_line1: '',
    });
    const [customerDocuments, setCustomerDocuments] = useState<IDocument>();
    const [leadProducts, setLeadProducts] = useState<ILeadProductEntity[]>([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [leadGurantor, setLeadGurantor] = useState<IGuarantor[]>([]);
    const [allComment, setAllComment] = useState<
        {
            key: string;
            name: string;
            text: string;
        }[]
    >([]);

    const setLeaddata = (item: IUserEntity) => {
        setCustomerInfo({
            id: item.id,
            first_name: item.first_name,
            last_name: item.last_name || '',
            email: item.email,
            primary_mobile: item.primary_mobile,
            secondary_mobile: item.secondary_mobile,
            cnic_number: item.cnic_number,
            dob: item.dob || '',
            gender: item.gender,
            province: item.province || '',
            city: item.city || '',
            address_line1: item.address_line1 || '',
        });

        const documents: IDocument = formateDbDocuments(item?.documents || []);

        setCustomerDocuments(documents);

        const allGurantors: IUserEntity[] = item.leads?.flatMap(lead => lead.guarantors) || [];
        const uniqueGurantors = Array.from(new Map(allGurantors.map(guarantor => [guarantor.id, guarantor])).values());

        const gurantors: IGuarantor[] = formateDbGurantors(uniqueGurantors);
        setLeadGurantor(gurantors);

        const allProducts: ILeadProductEntity[] = item.leads?.flatMap(lead => lead.products) || [];

        setLeadProducts(allProducts);
        console.log(allProducts);
        let allComments: ILeadCommentsEntity[] = [];
        item.leads?.forEach(lead => {
            if (lead.comments) allComments = [...allComments, ...lead.comments];
        }) || [];

        const comments = allComments?.map((comment, index) => {
            return {
                key: (index + 1).toString(),
                name: (comment.user?.first_name ?? '') + ' ' + (comment.user?.last_name ?? '') || 'N/A',
                text: comment.text,
            };
        });
        setAllComment(comments);
    };

    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        if (id) fetchCustomer(id);
    }, [id]);

    const customerInfoData = useMemo(() => {
        return {
            'User Id': customerInfo?.id?.slice(-9) ?? 'N/A',
            'First name': customerInfo?.first_name ?? 'N/A',
            'Last name': customerInfo?.last_name ?? 'N/A',
            Email: customerInfo?.email ?? 'N/A',
            'Phone Number': customerInfo?.primary_mobile ?? 'N/A',
            'Secondary phone': customerInfo?.secondary_mobile ?? 'N/A',
            CNIC: customerInfo?.cnic_number ?? 'N/A',
            DOB: customerInfo?.dob ?? 'N/A',
            Gender: customerInfo?.gender ?? 'N/A',
            Province: customerInfo?.province ?? 'N/A',
            City: customerInfo?.city ?? 'N/A',
            Address: customerInfo?.address_line1 ?? 'N/A',
        };
    }, [customerInfo]);

    const downloadAllDocuments = async () => {
        const zip = new JSZip();

        const addDocumentsToZip = async (files: UploadedFile[], category: string) => {
            const filePromises = files.map(async file => {
                try {
                    const preSignedUrl = await getFileFromFilename(file.url || '');

                    const response = await fetch(preSignedUrl);

                    const blob = await response.blob();

                    const fileName = file.file?.name || `${category}_${file.uid}.png`;

                    zip.file(fileName, blob);
                } catch (error) {
                    console.error(`Failed to fetch document: ${file.url}`, error);
                }
            });

            await Promise.all(filePromises);
        };
        if (customerDocuments) {
            // Add documents from each category to the ZIP
            await addDocumentsToZip(customerDocuments.profile_pic, 'profile_pic');
            await addDocumentsToZip(customerDocuments.cnic, 'cnic');
            await addDocumentsToZip(customerDocuments.bank_statment, 'bank_statement');
            await addDocumentsToZip(customerDocuments.bills, 'bills');
            await addDocumentsToZip(customerDocuments.salary_slip, 'salary_slip');
            await addDocumentsToZip(customerDocuments.cheque, 'cheque');
            await addDocumentsToZip(customerDocuments.other, 'other');
        }

        // After adding all documents, generate the ZIP file and trigger the download
        zip.generateAsync({ type: 'blob' }).then(content => {
            saveAs(content, 'all_documents.zip');
        });
    };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const hideModal = () => {
    setIsModalVisible(false);
  };

  const renderProductDetails = (products: ILeadProductEntity) => {
    return (
      <>
        <Row gutter={16} style={{ display: 'flex', alignItems: 'center' }}>
          <Col span={12} style={{ display: 'flex', justifyContent: 'space-between' }}>
            <TextTypography fontSize={14} style={{ marginBottom: '8px' }}>
              Product Type:
            </TextTypography>
            <TextTypography fontSize={16}>
              {products?.product_type?.name || 'N/A'}
            </TextTypography>
          </Col>
          <Col span={12} style={{ display: 'flex', justifyContent: 'space-between' }}>
            <TextTypography fontSize={14} style={{ marginBottom: '8px' }}>
              Brand:
            </TextTypography>
            <TextTypography fontSize={16}>
              {products?.brand?.name || 'N/A'}
            </TextTypography>
          </Col>
        </Row>

        <Row gutter={16} style={{ display: 'flex', alignItems: 'center' }}>
          <Col span={12} style={{ display: 'flex', justifyContent: 'space-between' }}>
            <TextTypography fontSize={14} style={{ marginBottom: '8px' }}>
              Product Description:
            </TextTypography>
            <TextTypography fontSize={16}>
              {products?.product_description || 'N/A'}
            </TextTypography>
          </Col>
          <Col span={12} style={{ display: 'flex', justifyContent: 'space-between' }}>
            <TextTypography fontSize={14} style={{ marginBottom: '8px' }}>
              Quantity:
            </TextTypography>
            <TextTypography fontSize={16}>
              {products?.quantity || 'N/A'}
            </TextTypography>
          </Col>
        </Row>

        <Row gutter={16} style={{ display: 'flex', alignItems: 'center' }}>
          <Col span={12} style={{ display: 'flex', justifyContent: 'space-between' }}>
            <TextTypography fontSize={14} style={{ marginBottom: '8px' }}>
              Delivery Charges:
            </TextTypography>
            <TextTypography fontSize={16}>
              {products?.delivery_charges || 'N/A'}
            </TextTypography>
          </Col>
          <Col span={12} style={{ display: 'flex', justifyContent: 'space-between' }}>
            <TextTypography fontSize={14} style={{ marginBottom: '8px' }}>
              Token Amount:
            </TextTypography>
            <TextTypography fontSize={16}>
              {products?.token_amount || 'N/A'}
            </TextTypography>
          </Col>
        </Row>

        <Row gutter={16} style={{ display: 'flex', alignItems: 'center' }}>
          <Col span={12} style={{ display: 'flex', justifyContent: 'space-between' }}>
            <TextTypography fontSize={14} style={{ marginBottom: '8px' }}>
              APR:
            </TextTypography>
            <TextTypography fontSize={16}>
              {products?.apr || 'N/A'}
            </TextTypography>
          </Col>
          <Col span={12} style={{ display: 'flex', justifyContent: 'space-between' }}>
            <TextTypography fontSize={14} style={{ marginBottom: '8px' }}>
              Retail Price:
            </TextTypography>
            <TextTypography fontSize={16}>
              {products?.retail_price || 'N/A'}
            </TextTypography>
          </Col>
        </Row>

        <Row gutter={16} style={{ display: 'flex', alignItems: 'center' }}>
          <Col span={12} style={{ display: 'flex', justifyContent: 'space-between' }}>
            <TextTypography fontSize={14} style={{ marginBottom: '8px' }}>
              Installment Plan:
            </TextTypography>
            <TextTypography fontSize={16}>
              {products?.instalment_plan?.name || 'N/A'}
            </TextTypography>
          </Col>
          <Col span={12} style={{ display: 'flex', justifyContent: 'space-between' }}>
            <TextTypography fontSize={14} style={{ marginBottom: '8px' }}>
              Monthly Installment:
            </TextTypography>
            <TextTypography fontSize={16}>
              {products?.retail_price && products?.instalment_plan?.cycle
                ? products.retail_price / products.instalment_plan.cycle
                : 'N/A'}
            </TextTypography>
          </Col>
        </Row>
      </>
    );
  };

  const ActionModal: React.FC<IFilterItemProps> = ({ children, item }: IFilterItemProps) => {
    const items: MenuProps['items'] = [
      {
        label: (
          <div
            onClick={() => {
              showModal();
            }}
            className="flex items-center gap-2"
          >
            <EyeOutlined className="w-[20px] h-[20px]" />
            <TextTypography fontSize={14}>View Product Details</TextTypography>
          </div>
        ),
        key: 'view',
      },

    ];

    return (
      <div>
        <Dropdown menu={{ items }} trigger={['click']} placement="topLeft" overlayStyle={{ marginLeft: '0px' }}>
          <a onClick={(e) => e.preventDefault()}>
            <Space wrap direction="vertical">
              {children}
            </Space>
          </a>
        </Dropdown>
      </div>
    );
  };

    const columns: ColumnsType<ILeadProductEntity> = [
        {
            title: 'Product Type',
            dataIndex: 'product_type.name',
            key: 'product_type.name',
            ellipsis: true,
            sorter: () => 0,
            sortDirections: ['ascend', 'descend'],
            render: (_: string, item) => (
                <TextTypography fontSize={16} classNames="cursor-pointer flex h-[40px] truncate items-center w-[120px]">
                    <Tooltip title={_}>{item.product_type.name}</Tooltip>
                </TextTypography>
            ),
        },
        {
            title: 'Quantity',
            dataIndex: 'quantity',
            key: 'quantity',
            ellipsis: true,
            sorter: () => 0,
            sortDirections: ['ascend', 'descend'],
            render: (_: string) => (
                <TextTypography fontSize={16} classNames="cursor-pointer flex h-[40px] truncate items-center w-[120px]">
                    <Tooltip title={_}>{_}</Tooltip>
                </TextTypography>
            ),
        },
        {
            title: 'Brand',
            dataIndex: 'brand.name',
            key: 'brand.name',
            ellipsis: true,
            sorter: () => 0,
            sortDirections: ['ascend', 'descend'],
            render: (_: string, item) => (
                <TextTypography fontSize={16} classNames="cursor-pointer flex h-[40px] truncate items-center w-[218px]">
                    <Tooltip title={_}>{item.brand.name}</Tooltip>
                </TextTypography>
            ),
        },
        {
            title: 'Product Name',
            dataIndex: 'product_name',
            key: 'product_name',
            ellipsis: true,
            sorter: () => 0,
            sortDirections: ['ascend', 'descend'],
            render: (_: string) => (
                <TextTypography fontSize={16} classNames="cursor-pointer flex h-[40px] truncate items-center w-[159px]">
                    <Tooltip title={_}>{_}</Tooltip>
                </TextTypography>
            ),
        },
        {
            title: 'Product Description',
            dataIndex: 'product_description',
            key: 'cnic_numproduct_descriptionber',
            ellipsis: true,
            sorter: () => 0,
            sortDirections: ['ascend', 'descend'],
            render: (_: string) => (
                <TextTypography fontSize={16} classNames="cursor-pointer flex h-[40px] truncate items-center w-[160px]">
                    <Tooltip title={_}>{_}</Tooltip>
                </TextTypography>
            ),
        },
      {
        title: 'Actions',
        dataIndex: 'operation',
        align: 'right',
        fixed: 'right',
        key: 'operation',
        render: (_: string, item: ILeadProductEntity) => (
          <div className="w-[60px] flex justify-end">
            <ActionModal item={item as ILeadProductEntity}>
              <Button type="text" shape="circle" icon={<MoreIcon />} className="!text-end h-[40px] w-[20px]" />
            </ActionModal>
          </div>
        ),
      },
    ];

    if (!id) return <></>;

    if (isLoading) {
        return (
            <div className="spinner-container flex justify-center p-[20px]">
                <Spin size="large" />
            </div>
        );
    }

    return (
        <>
            <BaseLayoutComponent
                children={
                    <Content className="m-5 bg">
                        <div className="flex justify-between">
                            {contextHolder}
                            <HeadingTypography fontSize={24}>View Customer Details</HeadingTypography>
                        </div>
                        <Card title="Customer Info" className="mb-4 mt-5">
                            <div className="grid grid-cols-2 gap-4">
                                {Object.entries(customerInfoData).map(([key, value], index) => (
                                    <DataRow key={key + index} title={key} value={value} index={index} />
                                ))}
                            </div>
                        </Card>

                        {/* leas */}
                        <Card title="Leads" className="mb-4">
                            <div className="border-2 border-black rounded-lg">
                                <Table columns={columns} dataSource={leadProducts} pagination={false} rowKey={'id'} size="small" scroll={{ x: true }} />
                            </div>
                        </Card>

                      <Modal
                        title="Lead Details"
                        visible={isModalVisible}
                        onCancel={hideModal}
                        footer={null}
                        width={800}
                        destroyOnClose
                      >
                        <Tabs defaultActiveKey="1" type="card">
                          {leadProducts.map((product, index) => (
                            <TabPane tab={`Product ${index + 1}`} key={index + 1}>
                              {renderProductDetails(product)}
                            </TabPane>
                          ))}
                        </Tabs>
                      </Modal>

                        <div className="flex">
                            {/* Guarantors */}
                            <Card title="Guarantors" className="mb-4 w-[50%] ">
                                <div className=" flex flex-col gap-[20px]">
                                    <GuarantorsDetails
                                        guarantors={leadGurantor}
                                        leadId={id}
                                        fetchExistingLead={() => {
                                            fetchCustomer(id);
                                        }}
                                    />
                                </div>
                            </Card>

                            {/* Comments */}
                            <Card title="Comments" className="mb-4 w-[50%]">
                                <div className="flex flex-col gap-[10px]">
                                    {allComment?.map(comment => (
                                        <div className="flex flex-col justify-start items-start gap-[10px] p-3 border rounded-lg bg-[#FAFAFA]">
                                            <HeadingTypography fontSize={14}>{comment.name}</HeadingTypography>
                                            <TextTypography fontSize={14}>{comment.text}</TextTypography>
                                        </div>
                                    ))}
                                </div>

                                {/* <div className="mt-5 flex gap-[10px]">
                                    <Input.TextArea
                                        onChange={e => {
                                            setComment(e.target.value);
                                        }}
                                        placeholder="Write a Comment"
                                        rows={1}
                                        className="mb-2"
                                    />
                                    <Button
                                        loading={isUpdateLoading}
                                        disabled={!comment}
                                        onClick={() => {
                                            updateLeadHandler({ isOnlyComment: true });
                                        }}
                                        type="primary"
                                    >
                                        Post
                                    </Button>
                                </div> */}
                            </Card>
                        </div>

                        <Card
                            title="Documents"
                            className="mb-4"
                            extra={
                                <Button
                                    type="link" // Removes the outline, making it look like a link
                                    onClick={downloadAllDocuments}
                                    style={{
                                        color: '#007AFF',
                                        fontSize: '16px',
                                        padding: 0,
                                        display: 'flex',
                                        flexDirection: 'row-reverse',
                                        alignItems: 'center',
                                        gap: '8px',
                                    }}
                                    icon={
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.5 9.1665V14.1665L9.16667 12.4998" stroke="#007AFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M7.50016 14.1667L5.8335 12.5" stroke="#007AFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path
                                                d="M18.3332 8.33317V12.4998C18.3332 16.6665 16.6665 18.3332 12.4998 18.3332H7.49984C3.33317 18.3332 1.6665 16.6665 1.6665 12.4998V7.49984C1.6665 3.33317 3.33317 1.6665 7.49984 1.6665H11.6665"
                                                stroke="#007AFF"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M18.3332 8.33317H14.9998C12.4998 8.33317 11.6665 7.49984 11.6665 4.99984V1.6665L18.3332 8.33317Z"
                                                stroke="#007AFF"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    }
                                >
                                    Download All
                                </Button>
                            }
                        >
                            <div
                                style={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(3, 1fr)',
                                    gap: '16px',
                                    maxWidth: '100%',
                                    overflowX: 'hidden',
                                }}
                            >
                                <DocumentsUpload title="Profile Picture" maxFiles={3} uploadFiles={() => {}} uploadedFiles={customerDocuments?.profile_pic} leadId={id ?? ''} isUploadAble={false} />
                                <DocumentsUpload title="CNIC" maxFiles={3} uploadFiles={() => {}} uploadedFiles={customerDocuments?.cnic} leadId={id ?? ''} isUploadAble={false} />
                                <DocumentsUpload title="Bank Statement" maxFiles={3} uploadFiles={() => {}} uploadedFiles={customerDocuments?.bank_statment} leadId={id ?? ''} isUploadAble={false} />
                                <DocumentsUpload title="Utility Bills" maxFiles={3} uploadFiles={() => {}} uploadedFiles={customerDocuments?.bills} leadId={id ?? ''} isUploadAble={false} />
                                <DocumentsUpload title="Salary Slip" maxFiles={3} uploadFiles={() => {}} uploadedFiles={customerDocuments?.salary_slip} leadId={id ?? ''} isUploadAble={false} />
                                <DocumentsUpload title="Cheque" maxFiles={3} uploadFiles={() => {}} uploadedFiles={customerDocuments?.cheque} leadId={id ?? ''} isUploadAble={false} />
                                <div style={{ gridColumn: 'span 3' }}>
                                    <DocumentsUpload title="Other" maxFiles={11} uploadFiles={() => {}} uploadedFiles={customerDocuments?.other} leadId={id ?? ''} isUploadAble={false} />
                                </div>
                            </div>
                        </Card>
                    </Content>
                }
            />
        </>
    );
};

const DataRow = ({ title, value, index }: { title: string; value: string; index: number }) => {
    return (
        <div className="flex justify-between">
            <TextTypography classNames="font-normal" fontSize={16}>
                {title}
            </TextTypography>
            <div className="flex">
                <TextTypography classNames="font-medium " fontSize={16}>
                    {value}
                </TextTypography>
                {!(index % 2) ? <div className="w-[1px] h-[70%] bg-[#DBD7D7] mt-[5px] ml-2"></div> : null}
            </div>
        </div>
    );
};

export default CustomerDetails;
